import { useState } from "react";
import domain from "../reusecomponent/domain";
import { getToken } from "../whatsapp/function/token";
import Swalaleart from "../whatsapp/function/swalaleart";

const BusinessModal = ({ open, onClose, data,lottieRef,setLoading }) => {
  const [selected, setSelected] = useState([]);

  if (!open) return null;

  /* Toggle single checkbox */
  const toggleOne = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  /* Select all */
  const toggleAll = (checked) => {
    if (checked) {
      setSelected(data.current.map((item) => item.locationId));
    } else {
      setSelected([]);
    }
  };

  /* Submit */
  const submit = async () => {          
        try{
          setLoading(true);
          const myHeaders = new Headers();
          const formdata = new FormData();
          const access_token = getToken();
          
          myHeaders.append(`Authorization`, `Bearer ${access_token}`);
          selected.forEach((id) => {
            formdata.append("store_code[]", id);
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
          };
          const res = await fetch(`${domain()}/gmb/gmb_add`, requestOptions)
          const result = await res.json();
          if(result.status){
            setTimeout(() => {
              data.current = [];
              lottieRef.current = true;
              onClose();
            }, 500);
          }else{
            Swalaleart({title: "Error",text: result.message || "Something Went Wrong",icon: "error",});
          }
        }catch(error){
          Swalaleart({title: "Error",text: "Internal server problem",icon: "error",});
        }finally{
          setLoading(false);
        }
  };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,.55)",
          zIndex: 999,
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "92%",
          maxWidth: 900,
          background: "#fff",
          borderRadius: 14,
          zIndex: 1000,
          boxShadow: "0 25px 60px rgba(0,0,0,.2)",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px 20px",
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #eee",
          }}
        >
          <h2 style={{ margin: 0 }}>Your Business Accounts</h2>
          <button
            onClick={onClose}
            style={{
              fontSize: 28,
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: 20 }}>
          {/* Select all */}
          <div style={{ marginBottom: 14 }}>
            <input
              type="checkbox"
              checked={selected.length === data.current.length && data.current.length > 0}
              onChange={(e) => toggleAll(e.target.checked)}
            />{" "}
            <strong>Select All</strong>
          </div>

          {/* Cards grid (AUTO-FIT FIXED) */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 16,
            }}
          >
            {data.current.map((item, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "flex",
                  gap: 14,
                  padding: 16,
                  borderRadius: 12,
                  border: "1px solid #eee",
                  background: "#fafafa",
                }}
              >
                {/* Checkbox top-right */}
                <input
                  type="checkbox"
                  checked={selected.includes(item.storeCode)}
                  onChange={() => toggleOne(item.storeCode)}
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                  }}
                />

                {/* Avatar */}
                {item.profilePicture ? (
                  <img
                    src={item.profilePicture}
                    alt={item.title}
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg,#4f46e5,#9333ea)",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 22,
                      fontWeight: 600,
                    }}
                  >
                    {item.title.charAt(0).toUpperCase()}
                  </div>
                )}

                {/* Info */}
                <div>
                  <h3 style={{ margin: 0, fontSize: 16 }}>
                    {item.title}
                  </h3>
                  <p
                    style={{
                      margin: "4px 0",
                      fontSize: 13,
                      color: "#555",
                    }}
                  >
                    {item.primaryCategory}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 12,
                      color: "#888",
                    }}
                  >
                    Store ID: {item.storeCode}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "16px 20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            borderTop: "1px solid #eee",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              borderRadius: 6,
              border: "none",
              background: "#e5e7eb",
            }}
          >
            Cancel
          </button>

          <button
            onClick={submit}
            disabled={selected.length === 0}
            style={{
              padding: "8px 16px",
              borderRadius: 6,
              border: "none",
              background: "#2563eb",
              color: "#fff",
              opacity: selected.length === 0 ? 0.6 : 1,
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default BusinessModal;